import React from 'react';
import { Button, ButtonProps, CircularProgress } from '@mui/material';

interface Props extends ButtonProps {
  loading: boolean;
}

const LoadingButton: React.FC<Props> = ({ 
  loading = false,
  color = 'primary',
  variant = 'contained',
  ...rest 
}) => {
  if (loading)
    return (
      <Button color='success' variant='contained' {...rest} disabled>
        <CircularProgress size={24} />
      </Button>
    );

  return <Button color={color} variant={variant} {...rest} />;
};

export default LoadingButton;
